export const FETCH_CALLS = 'FETCH_CALLS';
export const FETCH_CALLS_FAILURE = 'FETCH_CALLS_FAILURE';
export const FETCH_CLIENT_FAILURE = 'FETCH_CLIENT_FAILURE';
export const SELECT_CALL = 'SELECT_CALL';
export const SELECT_CALL_BY_PBX_ID = 'SELECT_CALL_BY_PBX_ID';
export const SET_CALLS = 'SET_CALLS';
export const SET_CLIENT = 'SET_CLIENT';
export const SET_CLIENT_ERROR = 'SET_CLIENT_ERROR';
export const SET_FILTERS = 'SET_CALLS_FILTERS';
export const SET_NEW_CALL = 'SET_NEW_CALL';
export const SET_PAGE = 'SET_CALLS_PAGE';
export const SET_SELECTED_CALL = 'SET_SELECTED_CALL';
export const UPDATE_CALLS = 'UPDATE_CALLS';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const UPDATE_CLIENT_IN_ALL_CALLS = 'UPDATE_CLIENT_IN_ALL_CALLS';
export const UPDATE_NEW_CALL = 'UPDATE_NEW_CALL';

export const RESET_ERRORS = 'RESET_ERRORS';
export const LISTEN_CALL_FAILURE = 'LISTEN_CALL_FAILURE';

export const fetchCalls = () => ({ type: FETCH_CALLS });

export const resetErrors = () => ({ type: RESET_ERRORS });

export const selectCall = payload => ({ payload, type: SELECT_CALL });

export const setFilters = payload => ({ payload, type: SET_FILTERS });

export const setPage = payload => ({ payload, type: SET_PAGE });

export const updateClient = payload => ({ payload, type: UPDATE_CLIENT });
